import { createAsyncThunk } from "@reduxjs/toolkit";
import {
	createCompanyApi,
	getCompanyByIdApi,
	updateCompanyApi,
} from "services/company";
import { RootState } from "store/store";

/**
 * Create Company Thunk
 */
export const createCompany = createAsyncThunk(
	"company/createCompany",
	async (companyData: Record<string, any>, { getState, rejectWithValue }) => {
		const state = getState() as RootState;
		try {
			const data = await createCompanyApi(companyData, state);
			return data;
		} catch (error: any) {
			console.error("Error creating company:", error);
			return rejectWithValue(
				error.response?.data || "Failed to create company",
			);
		}
	},
);

/**
 * Update Company Thunk
 */
export const updateCompany = createAsyncThunk(
	"company/updateCompany",
	async (
		{ id, companyData }: { id: number; companyData: Record<string, any> },
		{ getState, rejectWithValue },
	) => {
		const state = getState() as RootState;
		try {
			const data = await updateCompanyApi(id, companyData, state);
			return data.data;
		} catch (error: any) {
			console.error("Error updating company:", error);
			return rejectWithValue(
				error.response?.data || "Failed to update company",
			);
		}
	},
);

/**
 * Fetch Company By ID Thunk
 */
export const fetchCompanyById = createAsyncThunk(
	"company/fetchCompanyById",
	async (id: number, { getState, rejectWithValue }) => {
		const state = getState() as RootState;
		try {
			const data = await getCompanyByIdApi(id, state);
			return data.data;
		} catch (error: any) {
			console.error("Error fetching company:", error);
			return rejectWithValue(error.response?.data || "Failed to fetch company");
		}
	},
);
